'use strict';

var $ = require('../internals/export');

var $every = require('../internals/array-iteration').every;

var sloppyArrayMethod = require('../internals/sloppy-array-method'); // `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every


$({
  target: 'Array',
  proto: true,
  forced: sloppyArrayMethod('every')
}, {
  every: function every(callbackfn
  /* , thisArg */
  ) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});